import type { IntegrationStatus } from '@ventin/shared';
import { cn } from '@/lib/utils';

const STYLES: Record<IntegrationStatus, { bg: string; text: string; dot: string; copy: string }> = {
  CONNECTED: { bg: 'bg-[#ECFDF5]', text: 'text-[#16A34A]', dot: 'bg-[#16A34A]', copy: 'Connected' },
  DISCONNECTED: {
    bg: 'bg-[#F1F1F3]',
    text: 'text-[#4B4B52]',
    dot: 'bg-[#8A8A94]',
    copy: 'Not connected',
  },
  PENDING_OAUTH: {
    bg: 'bg-[#FFFBEB]',
    text: 'text-[#D97706]',
    dot: 'bg-[#D97706]',
    copy: 'Finish setup',
  },
  ERROR: {
    bg: 'bg-[#FEF2F2]',
    text: 'text-[#DC2626]',
    dot: 'bg-[#DC2626]',
    copy: 'Error — check details',
  },
};

export function StatusChip({ status }: { status: IntegrationStatus }) {
  const s = STYLES[status];
  return (
    <span
      aria-label={`Status: ${s.copy}`}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-[10px] py-1 text-[12px] font-medium tabular-nums',
        s.bg,
        s.text,
      )}
    >
      <span aria-hidden="true" className={cn('inline-block h-[6px] w-[6px] rounded-full', s.dot)} />
      {s.copy}
    </span>
  );
}
